<template>
	<v-flex xs12 class="ct-rightpane-schedule" v-if="schedule">
		<div class="pb-3 pt-3 " style="border-top: 1px solid lightgray;" v-bind:style="styleScheduleListRow">
		<v-layout wrap v-if="isEditable">
			<v-flex xs2 class="label">開始</v-flex>
			<v-flex xs6 blue--text>
				<v-menu
					ref="begin_calendar"
					v-model="begin_calendar"
					:close-on-content-click="false"
					:nudge-right="40"
					lazy
					transition="scale-transition"
					full-width
				>
					<template v-slot:activator="{ on }">
						<v-btn flat block class="blue--text subheading calendar-btn" v-on="on">
							{{ schedule.begin.strftimeDCL('%Y年%m月%d日 (%A)') }}
						</v-btn>
					</template>
					<v-date-picker
						v-model="scheduleBegin"
						no-title
						@input="onSelectBeginDate"
						locale="jp-ja"
						:day-format="date => new Date(date).getDate()"
					></v-date-picker>
				</v-menu>
			</v-flex>
			<v-flex xs2 blue--text>
				<v-menu
					ref="begin_time"
					v-model="begin_time"
					:close-on-content-click="false"
					:nudge-right="40"
					lazy
					transition="scale-transition"
					full-width
					v-if="!isAllday"
				>
					<template v-slot:activator="{ on }">
						<v-btn flat block class="blue--text subheading" v-on="on">{{ schedule.begin.strftimeDCL('%H:%M') }}</v-btn>
					</template>
					<v-time-picker
						v-model='scheduleTimeBegin'
						format="24hr"
						@click:minute="onSelectBeginTime"
					></v-time-picker>
				</v-menu>
			</v-flex>
			<v-flex xs2>
				<v-spacer></v-spacer>
				<v-btn small flat fab v-if=isDeletable  class="delete-schedule-btn" v-on:click="onDeleteSchedule"><v-icon>close</v-icon></v-btn>
			</v-flex>
		</v-layout>
		<v-layout wrap v-else>
			<v-flex xs2 class="label">開始</v-flex>
			<v-flex xs7 class="label">
				{{ schedule.begin.strftimeDCL('%Y年%m月%d日 (%A)') }}
			</v-flex>
			<v-flex xs2 class="label">
				<template v-if="!isAllday">
					{{ schedule.begin.strftimeDCL('%H:%M') }}
				</template>
			</v-flex>
			<v-flex xs1 class="multi-line-label"></v-flex>
		</v-layout>
		
		<v-layout wrap mt-2 v-if="isEditable">
			<v-flex xs2 class="label">終了</v-flex>
			<v-flex xs6>
				<v-menu
					ref="end_calendar"
					v-model="end_calendar"
					:close-on-content-click="false"
					:nudge-right="40"
					lazy
					transition="scale-transition"
					full-width
				>
					<template v-slot:activator="{ on }">
						<v-btn flat block class="blue--text subheading calendar-btn" v-on="on">
							{{ schedule.end.strftimeDCL('%Y年%m月%d日 (%A)') }}
						</v-btn>
					</template>
					<v-date-picker
						v-model="scheduleEnd"
						no-title
						@input="onSelectEndDate"
						locale="jp-ja"
						:day-format="date => new Date(date).getDate()"
					></v-date-picker>
				</v-menu>
			</v-flex>
			<v-flex xs2>
				<v-menu
					ref="end_time"
					v-model="end_time"
					:close-on-content-click="false"
					:nudge-right="40"
					lazy
					transition="scale-transition"
					full-width
					v-if="!isAllday" 
				>
					<template v-slot:activator="{ on }">
						<v-btn flat block class="blue--text subheading" v-on="on">
							{{ schedule.end.strftimeDCL('%H:%M') }}
						</v-btn>
					</template>
					<v-time-picker
						v-model='scheduleTimeEnd'
						format="24hr"
						@click:minute="onSelectEndTime"
					></v-time-picker>
				</v-menu>
			</v-flex>
			<v-flex xs2></v-flex>
		</v-layout>
		<v-layout wrap mt-2 v-else>
			<v-flex xs2 class="label">終了</v-flex>
			<v-flex xs7 class="label">
				{{ schedule.end.strftimeDCL('%Y年%m月%d日 (%A)') }}
			</v-flex>
			<v-flex xs2 class="label">
				<template v-if="!isAllday">
					{{ schedule.end.strftimeDCL('%H:%M') }}
				</template>
			</v-flex>
			<v-flex xs1 class="multi-line-label"></v-flex>
		</v-layout>
		
		<v-layout wrap mt-2>
			<v-flex xs2></v-flex>
			<v-flex xs6 pt-1 pl-1 class="multi-line-label">終日</v-flex>
			<v-flex xs3>
				<template v-if="isEditable">
					<v-switch
						style="padding-left:.5rem"
						class="all-day-tggle"
						v-model="isAllday"
					></v-switch>
				</template>
				<div v-else class="multi-line-label pt-1" style="padding-left:1.5rem;">
					{{ dispayAlldayText }}
				</div>
			</v-flex>
			<v-flex xs1></v-flex>
		</v-layout>
		<v-layout wrap mt-2 v-if="isLast && isEditable">
			<v-flex xs8 offset-xs2>
				<v-btn flat block blue--text class="add-schedule-btn label" v-on:click="onAddSchedule">スケジュールを追加</v-btn>
			</v-flex>
		</v-layout>
		</div>
	</v-flex>
</template>
<script>
import {strftime} from '../classes/Const';
import Util from '../classes/Util';
import ScheduleTick from '../classes/ScheduleTick';

export default {
	name: "RightPaneTaskScheduleList",
	props: [
		'schedule',
		'isPositionLast',
		'deletable',
		'isEditable',
	],
	data: function() {
		return {
			isAllday: this.schedule.all_day,
			begin_calendar: false,
			end_calendar: false,
			begin_time: false,
			end_time: false,
			strftime: strftime,
		}
	},
	methods: {
		onSelectBeginDate: function() {
			this.begin_calendar = false;
		},
		onSelectEndDate: function() {
			this.end_calendar = false;
		},
		onSelectBeginTime: function() {
			this.begin_time = false;
		},
		onSelectEndTime: function() {
			this.end_time = false;
		},
		toggleAllDay:function(){
			this.isAllday = !this.isAllday
		},
		formatDate: function (date) {
			const [year, month, day] = date.split('-')
			return `${year}${month}${day}`
		},
		formatTime: function(time){
			const [hour, min] = time.split(':')
			return `${hour}${min}`
		},
		onAddSchedule: function(){
			this.$emit('add-schedule');
		},
		onDeleteSchedule: function(){
			this.$emit('delete-schedule',this.schedule);
		},
		changePickerState: function(val){
			if (val){
				this.$emit('on-change-picker-state', {
					isShow: val
				});
			} else{
				if (this.isNotExistsEnablePicker())
					setTimeout(() =>{
						this.$emit('on-change-picker-state', {
							isShow: val
						})
					},100);
			}
		},
		isNotExistsEnablePicker: function(){
			if (this.begin_calendar)
				return false;
			if (this.end_calendar)
				return false;
			if (this.begin_time)
				return false;
			if (this.end_time)
				return false;
			return true;
		}
	},
	computed: {
		dispayAlldayText: function(){
			if (this.schedule.all_day){
				return "オン";
			} else {
				return "オフ";
			}
		},
		isLast:function(){
			return this.isPositionLast;
		},
		isDeletable: function(){
			return this.deletable;
		},
		styleScheduleListRow: function(){
			if(this.isPositionLast){
				return 'border-bottom:1px solid lightgray;';
			} else {
				return false;
			}
		},
		scheduleBegin: {
			get: function() {
				if (this.schedule.begin) {
					return this.schedule.begin.strftimeDCL('%Y-%m-%d');
				} else {
					return strftime('%Y-%m-%d', new Date().toISOString().substr(0, 10));
				}
			},
			set: function(begin) {
				let date = this.formatDate(begin);
				let code =  date + this.schedule.begin.strftimeDCL('%H%M');
				let dirty_schedule = this.schedule.begin.asDate;
				this.schedule.begin = new ScheduleTick({ code: code });
				let diffdate = Util.getDiffDay(this.schedule.begin.asDate,dirty_schedule);
				this.schedule.end = new ScheduleTick({ code: this.schedule.end.addDays(diffdate).strftimeDCL('%Y%m%d%H%M') });
			}
		},
		scheduleEnd: {
			get: function() {
				if (this.schedule.end) {
					return this.schedule.end.strftimeDCL('%Y-%m-%d');
				} else {
					return strftime('%Y-%m-%d', new Date().toISOString().substr(0, 10));
				}
			},
			set: function(end) {
				let date = this.formatDate(end);
				let code =  date + this.schedule.end.strftimeDCL('%H%M');
				this.schedule.end = new ScheduleTick({ code: code });
				let diffdate = Util.getDiffDay(this.schedule.begin.asDate,this.schedule.end.asDate);
				if (diffdate > 0){
					this.schedule.begin =  new ScheduleTick({ code: this.schedule.end.strftimeDCL('%Y%m%d') + this.schedule.begin.strftimeDCL('%H%M')});
				}
			}
		},
		scheduleTimeBegin: {
			get: function() {
				if (this.schedule.begin) {
					return this.schedule.begin.strftimeDCL('%H:%M');
				} else {
					return ''
				}
			},
			set: function(begin) {
				let time = this.formatTime(begin);
				let code = this.schedule.begin.strftimeDCL('%Y%m%d') + time;
				let dirty_schedule = this.schedule.begin.asDate;
				this.schedule.begin = new ScheduleTick({ code: code });

				let diffminitsu = Util.getDiffMinutes(this.schedule.begin.asDate,dirty_schedule);
				this.schedule.end = new ScheduleTick({ code: this.schedule.end.addMinutes(diffminitsu).strftimeDCL('%Y%m%d%H%M') });
			}
		},
		scheduleTimeEnd: {
			get: function() {
				if (this.schedule.end) {
					return this.schedule.end.strftimeDCL('%H:%M');
				} else {
					return ''
				}
			},
			set: function(end) {
				let time = this.formatTime(end);
				let code = this.schedule.end.strftimeDCL('%Y%m%d') + time;
				this.schedule.end = new ScheduleTick({ code: code });

				let difftime = Util.getDiffMinutes(this.schedule.begin.asDate,this.schedule.end.asDate);
				if (difftime > 0){
					this.schedule.begin =  new ScheduleTick({ code: this.schedule.begin.strftimeDCL('%Y%m%d') + this.schedule.end.strftimeDCL('%H%M') });
				}
			}
		},
	},
	mounted: function() {
	},
	watch: {
		isAllday: function() {
			this.schedule.all_day = this.isAllday;
		},
		begin_time:function(val){
			this.changePickerState(val);
		},
		end_time:function(val){
			this.changePickerState(val);
		},
		end_calendar:function(val){
			this.changePickerState(val);
		},
		begin_calendar:function(val){
			this.changePickerState(val);
		},
	},
	beforeDestroy: function() {
	},
};
</script>
<style>
	.ct-rightpane-schedule .calendar-btn{
		display: inline-block;
		text-align: justify;
		text-align-last: justify;
	}
	.ct-rightpane-schedule .all-day-tggle{
		margin-top:0;
	}
	.ct-rightpane-schedule .all-day-tggle .v-input__slot{
		margin-bottom: 0 !important;
	}
	.ct-rightpane-schedule .v-btn{
		height: 25px;
		min-width: 40px;
		margin: 0px;
	}
	.ct-rightpane-schedule .add-schedule-btn{
		color: #2196f3 !important;
	}
	.ct-rightpane-schedule .delete-schedule-btn{
		height: 24px;
		width: 24px;
		margin: 0;
		min-width: 24px;
		margin-left: 2.2em;
	}
	.ct-rightpane-schedule.edit-schedule-btn{
		padding: 0;
	}
</style>
